import { extractUniDataTableRows } from '@/common/utils/extractUniDataTableRows'
import { isUniDataTableFieldShape } from '@/common/utils/omitEmptyUniDataTableFieldsFromReloadPayload'

/** Tables the reload replaced with an empty one. Not tied to a single field name. */
export function tablesEmptiedByReload(
  localFields: Record<string, unknown> | null | undefined,
  appliedFields: Record<string, unknown> | null | undefined,
): string[] {
  if (!appliedFields) return []
  const local = localFields ?? {}
  const names: string[] = []
  for (const [key, value] of Object.entries(appliedFields)) {
    if (!isUniDataTableFieldShape(value) && !isUniDataTableFieldShape(local[key])) continue
    if (extractUniDataTableRows(local[key]).length === 0) continue
    if (extractUniDataTableRows(value).length > 0) continue
    names.push(key)
  }
  return names
}

export function tablesWithRows(
  fieldNames: readonly string[],
  fields: Record<string, unknown> | null | undefined,
): string[] {
  if (!fields) return []
  return fieldNames.filter((name) => extractUniDataTableRows(fields[name]).length > 0)
}
